import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  OCTOBER_ROSE_SETTING,
  OCTOBRE_ROSE_CLASS,
  OctobreRoseSwitch,
  readOctobreRoseSwitch,
  wearsOctobreRose,
} from './octobre-rose';

/**
 * Puts the campaign's class on the document, or takes it off.
 *
 * WHY IT NEVER THROWS AND NEVER WAITS LONG. This runs while the application is
 * starting. Whatever the API does, whether it answers slowly, answers rubbish,
 * or does not answer at all, the member must get their application. So the
 * question is asked with a two second limit, every failure is swallowed, and
 * the dates answer on their own when the API said nothing.
 *
 * The route it calls has been in the released API since December 2025, so the
 * guard on routes ahead of the released API has nothing to say about it.
 */
@Injectable({ providedIn: 'root' })
export class OctobreRoseService {
  private readonly http = inject(HttpClient);

  /** Two seconds, because nothing on the first screen depends on the answer. */
  private static readonly PATIENCE = 2000;

  async apply(now: Date = new Date()): Promise<boolean> {
    const said = await this.ask();
    const wears = wearsOctobreRose(said, now);

    document.documentElement.classList.toggle(OCTOBRE_ROSE_CLASS, wears);

    return wears;
  }

  private async ask(): Promise<OctobreRoseSwitch> {
    try {
      const answer = await firstValueFrom(
        this.http
          .get<{ value?: string }>(
            `${environment.api}/api/v1/system-setting/get-system-setting-by-key`,
            { params: { key: OCTOBER_ROSE_SETTING } },
          )
          .pipe(timeout(OctobreRoseService.PATIENCE)),
      );

      return readOctobreRoseSwitch(answer?.value);
    } catch {
      // No answer is not "off": it is "you decide from the dates".
      return 'unset';
    }
  }
}
